import { render, staticRenderFns } from "./DataAnalysisTablesListComponent.vue?vue&type=template&id=82e6e478"
import script from "./DataAnalysisTablesListComponent.vue?vue&type=script&lang=js"
export * from "./DataAnalysisTablesListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports